import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { Product } from './components/product';
import { Products } from './components/products';
import { ProductsFilterPage } from './components/productsFilterPage';
import { productsPaths } from './productsPaths';

export const productsRoutes = [
  {
    path: `${productsPaths.root}/:productId`,
    element: <Product />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: productsPaths.root,
    element: <Products />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
  {
    path: `${productsPaths.root}/filters`,
    element: <ProductsFilterPage />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
];
